import { Permission } from '@traton/devportal-rbac-common-lib';

export const developerPortalSupportAgentReadPermission: Permission = {
  name: 'developerPortalSupportAgent.read',
  description:
    'Allows reading assistant conversations, predefined prompts, and RAG index status',
  type: 'basic',
  attributes: { action: 'read' },
};

export const developerPortalSupportAgentCreatePermission: Permission = {
  name: 'developerPortalSupportAgent.create',
  description:
    'Allows starting a conversation and sending messages to the assistant',
  type: 'basic',
  attributes: { action: 'create' },
};

export const developerPortalSupportAgentUpdatePermission: Permission = {
  name: 'developerPortalSupportAgent.update',
  description: 'Allows updating assistant conversations',
  type: 'basic',
  attributes: { action: 'update' },
};

export const developerPortalSupportAgentDeletePermission: Permission = {
  name: 'developerPortalSupportAgent.delete',
  description:
    'Allows deleting assistant conversations and running RAG maintenance (e.g. orphan documentation cleanup)',
  type: 'basic',
  attributes: { action: 'delete' },
};

export const developerPortalSupportAgentPermissions = [
  developerPortalSupportAgentReadPermission,
  developerPortalSupportAgentCreatePermission,
  developerPortalSupportAgentUpdatePermission,
  developerPortalSupportAgentDeletePermission,
];
